import { Button, Dialog } from '@/components/ui';
import type { PendingOutsideRx } from './outside-rx';
import styles from './dispensary.module.css';

const noop = () => {};

/**
 * RL-1159: 409 OUTSIDE_PRESCRIPTION_ISSUED. The pharmacist checks with the
 * patient before supplying here, which cancels the outside prescription.
 */
export function OutsideRxConfirmDialog({
  pending,
  confirming,
  onConfirm,
  onCancel,
}: {
  pending: PendingOutsideRx | null;
  confirming: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const number =
    pending?.conflict.documentNumber ??
    pending?.rx.outsidePrescription?.documentNumber ??
    null;
  const packing = !!pending?.body.delivery;
  return (
    <Dialog
      open={!!pending}
      onClose={confirming ? noop : onCancel}
      variant="modal"
      dismissible={!confirming}
      title="Outside prescription issued"
      footer={
        <>
          <Button onClick={onCancel} disabled={confirming}>
            Cancel
          </Button>
          <Button variant="danger" loading={confirming} onClick={onConfirm}>
            {packing ? 'Pack here and cancel it' : 'Supply here and cancel it'}
          </Button>
        </>
      }
    >
      {pending && (
        <div className={styles.confirm}>
          <p>
            {`This patient has a valid outside-pharmacy prescription${
              number ? ` ${number}` : ''
            } — supplying here will cancel it. Confirm with the patient first.`}
          </p>
          <p className={styles.hint}>
            {pending.rx.patient.fullName} · {pending.rx.number}. Ask whether
            they already bought these medicines at a pharmacy. If you continue,
            the outside prescription is cancelled and the patient is notified.
          </p>
        </div>
      )}
    </Dialog>
  );
}
